module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "landing-clients"
  }, [_c('div', {
    staticClass: "video-container"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/jmOSJZ9ASs4?rel=0&controls=0&showinfo=0",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticClass: "title-row"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_c('h2', [_vm._v("Feito para uma cerreira sem limites.")])])]), _vm._v(" "), _c('div', {
    staticClass: "clients-list row"
  }, [_c('div', {
    staticClass: "client-item col-3 md-col-4 sm-col-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/sympla.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "client-item col-3 md-col-4 sm-col-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/conectcar.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "client-item col-3 md-col-4 sm-col-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ticketmais.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "client-item col-3 md-col-4 sm-col-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/rafarillo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "client-item col-3 md-col-4 sm-col-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/webaula.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "client-item col-3 md-col-4 sm-col-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/benfeitoria.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "client-item col-3 md-col-4 sm-col-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/estantevirtual.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "client-item col-3 md-col-4 sm-col-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/enjoei.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "client-item col-3 md-col-4 sm-col-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/elo7.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "client-item col-3 md-col-4 sm-col-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/positivo.png"),
      "alt": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7620c796!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingClients.vue
// module id = 144
// module chunks = 1